import { Chip, Tooltip } from "@mui/material";
import PropTypes from "prop-types";
import { STATUS_COLORS, STATUS_LABELS } from "../utils/fileManagerConstants";

const FileStatusBadge = ({ status, errorMessage }) => {
  const color = STATUS_COLORS[status] || STATUS_COLORS.PENDING;
  const label = STATUS_LABELS[status] || status;

  const chipElement = (
    <Chip
      label={label}
      size="small"
      sx={{
        backgroundColor: color,
        color: "#FFFFFF",
        fontWeight: 500,
        fontSize: "0.75rem",
        height: "24px",
      }}
    />
  );

  // Show tooltip with error message for failed status
  if (status === "FAILED" && errorMessage) {
    return (
      <Tooltip title={errorMessage} arrow placement="top">
        {chipElement}
      </Tooltip>
    );
  }

  return chipElement;
};

FileStatusBadge.propTypes = {
  status: PropTypes.oneOf([
    "PENDING",
    "PROCESSING",
    "COMPLETED",
    "FAILED",
    "EXPIRED",
  ]).isRequired,
  errorMessage: PropTypes.string,
};

export default FileStatusBadge;
